import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from "../../divider";
import { StyledTypo, Wrapper } from "./Navigation.styles";
export function CurrentSelected({ title }) {
    return (_jsxs(Wrapper, { children: [_jsx(StyledTypo, Object.assign({ variant: "p2" }, { children: title })), _jsx(Divider, {})] }));
}
